import { useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from "react-redux";

import { getHumanizeTime } from "../../../utils";
import Link from 'next/link';
import { openChatBox } from './../../../store/actions/messages';
import { Base64 } from 'js-base64';
import orderBy from 'lodash/orderBy';
// import "./style.scss";

const _ = {
    orderBy: orderBy
}

function Notifications(props) {
    const { showNotif, showMsgs, setShowList } = props;
    const [searchedMsg, setSearchedMsg] = useState('');
    const dispatch  = useDispatch();
    const { notifications, allChatThreads } = useSelector((state) => ({
        notifications: state.networkReducer.notifications,
        allChatThreads: state.messagesReducer.allChatThreads,
    }), shallowEqual);
    
    return (
        <div className={`notif-list-container ${showNotif ? 'notif-list-right' : ''}`}>
            <div className="list-header">
                <div className="header-label">
                    {
                        showNotif ? "Notifications" : showMsgs ? "Messages" : ''
                    }
                </div>
                {
                    showMsgs &&
                    <form className="search-msgs">
                        <img src={`${process.env.IMAGES_BASE_URL}/static-content/search.png.webp`} alt="search"/>
                        <input placeholder="Search Messages" className="input-contral false" value={searchedMsg} onChange={(e) => setSearchedMsg(e.target.value)} />
                    </form>
                }
            </div>
            {
                showNotif &&
                <ul className="notif-list">
                    {
                        notifications && notifications.map((n, index) => {
                            const href = n?.post_id ? `/post?id=${Base64.encode(n?.post_id)}` : n?.message == "accepted your friend request." ? `/network` : `/network/requests`;
                            return (
                                <li className={`nitem ${!!n.is_unread ? 'unread' : ''}`} key={index}>
                                    <Link href={href} as={href}>
                                        <a><div className="ntime">{getHumanizeTime(n?.created_at)}</div>
                                        <div className="ncontent">
                                            <div className="nimage">
                                                <img src={n?.user?.image_url || `${process.env.IMAGES_BASE_URL}/static-content/empty-profile.png.webp`} />
                                            </div>
                                            <div className="ntext"><b>{n?.user?.first_name} {n?.user?.show_last_name && n?.user?.last_name}</b>{` ${n.message}.`}</div>
                                        </div></a>
                                    </Link>
                                </li>
                            )
                        })
                    }
                    {
                        (!!notifications && !notifications.length) &&
                            <div className="nodata-block mt-0 pt-0">
                                <span className="nodata-img"><img src="/icons/empty-network.png" alt="search" /></span>
                                <label>Its looks like you don't have any notification yet</label>
                            </div>
                    }
                </ul>
            }
            {
                showMsgs &&
                <ul className="notif-list">
                    {
                        allChatThreads &&
                        _.orderBy(allChatThreads, (e) => { return e?.unread_messages_count || e?.messages[0]?.created_at || e?.created_at}, ['desc'])
                        .filter(f => ((f.first_name+" "+f.show_last_name ? f.last_name : '').toLowerCase()).includes(searchedMsg.toLowerCase())).map((m, index) => {
                            return (
                                <li className={`nitem ${!!m.unread_messages_count ? 'unread' : ''}`} key={index} onClick={() => {dispatch(openChatBox(m)); setShowList(false)}}>
                                    <div className="ntime">{ !!m?.messages[0]?.created_at ? getHumanizeTime(m?.messages[0]?.created_at) : ''}</div>
                                    <div className="ncontent">
                                        <div className="nimage">
                                            <img src={m?.image_url || `${process.env.IMAGES_BASE_URL}/static-content/empty-profile.png.webp`} />
                                        </div>
                                        <div className="ntext">
                                            <div className="mname">{m?.first_name} {m?.show_last_name && m?.last_name}</div>
                                            {m?.messages[0]?.message || 'click here to start chat!'}
                                        </div>
                                        {
                                            !!m.unread_messages_count &&
                                            <div className="unread-count">
                                                {"+"+m.unread_messages_count}
                                            </div>
                                        }
                                    </div>
                                </li>
                            )
                        })
                    }
                    {
                        (!!allChatThreads && !allChatThreads.length) &&
                            <div className="nodata-block mt-0 pt-0">
                                <span className="nodata-img"><img src="/icons/empty-network.png" alt="search" /></span>
                                <label>Its looks like you don't have any conection yet</label>
                                <a className="more-btn" href="/network">View more suggestions</a>
                            </div>
                    }
                </ul>
            }
        </div>
    );
};

export default Notifications;
